export enum EventCancellationAire {
  LossCitizenshipOpeLegis = '5',
  LossCitizenshipForeignNaturalization = '6',
  RenunciationItalianCitizenship = '7',
}
